module.exports = __webpack_public_path__ + "static/media/safeZone.420d162f.svg";